import moment from "moment";
import { getLongLocaleCode, getLocale } from '@/i18n/index';

export const filters = {
  formatDate: (date: any, format?: string) => moment(date).format(format ? format: "DD.MM.YYYY"),
  formatTime: (time: any) => moment(time, "hh:mm A").format("HH:mm"),
  formatDateWithTime: (dateWithTime: any) => moment(dateWithTime).format("DD.MM.YYYY HH:mm"),
  formatAmount: (value: any, arg: string) => {
    const euro = value / 100;
    const localeString = getLongLocaleCode(getLocale());
    const formattedValue = euro.toLocaleString(localeString,
      {
        style: "currency",
        currency: arg,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
    return formattedValue;
  }
};

export type Filters = typeof filters;
